<select class="time-zones-select"
        [formControl]="inputControl"
        [attr.id]="id"
        (click)="changeGmtId()">
    @for (item of forms.timeZones; track item.gmt) {
        <option class="time-zones-option" [value]="item.id">
            @if (subtitles.language === 'pl') {
                {{ 'GMT ' + item.gmt + ' ' + item.pl }}
            } @else if (subtitles.language === 'ru') {
                {{ 'GMT ' + item.gmt + ' ' + item.ru }}
            } @else {
                {{ 'GMT ' + item.gmt + ' ' + item.en }}
            }
        </option>
    }
</select>
